export default class Accordion {
    /**
     * Toggling the accordions when the provided accordion buttons are clicked
     * @param {Funcion} postFunction
     * @param {NodeList | String } accordionsButtons
     */
    constructor(postFunction = () => {}, accordionButtons = ".accordion-btn") {
        /** {NodeList} */
        let buttons;
        this.postFunction = postFunction;

        if(typeof accordionButtons === 'string') {
            buttons = document.querySelectorAll(accordionButtons);
        } else {
            buttons = accordionButtons;
        }

        if(!buttons) {
            console.warn("Accordion.js - No accordions found on current page, ignore if intentional.");
        }

        Array.from(buttons).forEach(btn => {
            btn.addEventListener('click', e => {
                this.toggleAccordion(e, btn);
            })
        })
    }

    /**
     * Adding active class and whatever animation is set on button.
     * @param {MouseEvent} e event from click event
     * @param btn {HTMLElement} Button that has been clicked
     */
    toggleAccordion(e, btn) {
        let target = document.querySelector(btn.dataset.accordion) ?? btn.nextElementSibling;
        target.classList.toggle("active");
        btn.classList.toggle("active");

        if(target.classList.contains('active')) {
            this.postFunction();
        }

        if(btn.dataset.animation) {
            target.classList.toggle(btn.dataset.animation)
        }
    }
}